<h2>{{ 'addToCart.cart.title' | transloco }}</h2>

<p class="cart-disclaimer text-subtle-gray_1000">
  {{ 'addToCart.cart.disclaimer' | transloco }}
</p>

<form [formGroup]="cartForm">
  <div
    class="form-field"
    [ngClass]="{ 'single-date-mode-form-field': isSingleDateMode }"
  >
    <mat-label>{{
      startDateLabel ? startDateLabel : ('addToCart.cart.startDate' | transloco)
    }}</mat-label>
    <mat-form-field
      appearance="outline"
      floatLabel="auto"
      (click)="startDatePicker.open()"
    >
      <input
        matInput
        formControlName="startDate"
        placeholder="dd-mm-yyyy"
        [matDatepicker]="startDatePicker"
        [min]="minDate"
        [max]="maxStartDate"
        readonly="true"
        [matDatepickerFilter]="nonWorkingDatesFilterWrapper"
      />
      <mat-datepicker-toggle [for]="startDatePicker" matSuffix>
        <fa-icon matDatepickerToggleIcon [icon]="faCalenderAlt"></fa-icon>
      </mat-datepicker-toggle>
      <mat-datepicker
        [touchUi]="isMobile$ | async"
        #startDatePicker
      ></mat-datepicker>
    </mat-form-field>
  </div>

  @if (!isSingleDateMode) {
    <div class="form-field">
      <mat-label>{{
        endDateLabel ? endDateLabel : ('addToCart.cart.endDate' | transloco)
      }}</mat-label>
      <mat-form-field
        appearance="outline"
        floatLabel="auto"
        (mousedown)="endDatePicker.open()"
      >
        <input
          matInput
          formControlName="endDate"
          placeholder="dd-mm-yyyy"
          [matDatepicker]="endDatePicker"
          [min]="minEndDate"
          [max]="maxDate"
          readonly="true"
          [matDatepickerFilter]="nonWorkingDatesFilterWrapper"
        />
        <mat-datepicker
          [touchUi]="isMobile$ | async"
          #endDatePicker
        ></mat-datepicker>
        <mat-datepicker-toggle [for]="endDatePicker" matSuffix>
          <fa-icon matDatepickerToggleIcon [icon]="faCalenderAlt"></fa-icon>
        </mat-datepicker-toggle>
      </mat-form-field>
    </div>
  }
</form>
